var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QAvatar',_vm._b({class:['sai-avatar', { bottom: _vm.bottom, 'overflow-hidden': _vm.bottom }],attrs:{"color":_vm.color,"text-color":_vm.textColor,"icon":_vm.icon,"font-size":_vm.fontSize}},'QAvatar',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }